// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const OthersGradientIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#others-gradient_svga)"
      d="M15.12 4q-.43.05-.72.38-.3.32-.3.77v9.73c.01.3.13.6.34.8q.33.34.8.34h3.64v2.83H7.78q-.44.05-.72.37-.3.34-.3.78v3.97H3.13q-.46 0-.8.34-.31.33-.32.8v9.74c0 .3.12.6.33.81.2.22.5.34.8.34h9.52c.3 0 .6-.12.8-.34q.33-.33.33-.81v-9.73c0-.3-.12-.6-.33-.81q-.33-.34-.8-.34H9.02v-2.82h21.96v2.82h-3.63q-.47 0-.8.34-.32.33-.33.8v9.74c0 .3.11.6.33.81.2.22.5.34.8.34h9.52q.47 0 .8-.34.32-.33.33-.81v-9.73c0-.3-.12-.6-.33-.81q-.33-.34-.8-.34h-3.64V20c0-.3-.12-.6-.33-.81q-.32-.33-.79-.34H21.13v-2.83h3.63q.47 0 .8-.33.32-.34.33-.81V5.15c0-.3-.12-.6-.33-.81q-.33-.33-.8-.34h-9.64"
    />
    <defs>
      <linearGradient
        id="others-gradient_svga"
        x1={2}
        x2={34.76}
        y1={4}
        y2={39.03}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "OthersGradient",
);
export default OthersGradientIcon;
